import * as runtime from '../../runtime';
import { IInitializeServiceOptions } from '../../types';
import { GetAssignedEditionsResponse, GetLicenseInfoResponse, IGetAssignedEditionsRequest, IGetLicenseInfoRequest } from './models';

export class IICsLicenseService extends runtime.BaseAPI {
	constructor(
		configuration: runtime.Configuration,
		private tenantId: string,
	) {
		super(configuration);
	}
	async getLicenseInfoByOrgIdRaw(
		requestParameters: IGetLicenseInfoRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction,
	): Promise<runtime.ApiResponse<GetLicenseInfoResponse>> {
		if (requestParameters.orgId === null || requestParameters.orgId === undefined) {
			throw new runtime.RequiredError('orgId', 'Required parameter requestParameters.orgId was null or undefined when calling getLicenseInfoByOrgId.');
		}

		const queryParameters: runtime.HTTPQuery = {};
		const headerParameters: runtime.HTTPHeaders = {};
		const response = await this.request({
			path: `/api/v1/OrgLicenseAssignment('${requestParameters.orgId}')/EffectiveLicenses()`,
			method: 'GET',
			headers: headerParameters,
			query: queryParameters,
		});

		return new runtime.JSONApiResponse(response);
	}
	async getLicenseInfoByOrgId(
		requestParameters: IGetLicenseInfoRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction,
	): Promise<GetLicenseInfoResponse> {
		const response = await this.getLicenseInfoByOrgIdRaw(requestParameters, initOverrides);
		return response.value();
	}
	async getAssignedEditionsByOrgIdRaw(
		requestParameters: IGetAssignedEditionsRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction,
	): Promise<runtime.ApiResponse<GetAssignedEditionsResponse>> {
		if (requestParameters.orgId === null || requestParameters.orgId === undefined) {
			throw new runtime.RequiredError('orgId', 'Required parameter requestParameters.orgId was null or undefined when calling getAssignedEditionsByOrgId.');
		}

		const queryParameters: runtime.HTTPQuery = {};
		const headerParameters: runtime.HTTPHeaders = {};
		const response = await this.request({
			path: `/api/v1/OrgLicenseAssignment('${requestParameters.orgId}')/Views()`,
			method: 'GET',
			headers: headerParameters,
			query: queryParameters,
		});

		return new runtime.JSONApiResponse(response);
	}
	async getAssignedEditionsByOrgId(
		requestParameters: IGetAssignedEditionsRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction,
	): Promise<GetAssignedEditionsResponse> {
		const response = await this.getAssignedEditionsByOrgIdRaw(requestParameters, initOverrides);
		return response.value();
	}
}
export const initializeLicenseService = ({ fetchApi, serviceBaseURLs, tenantId }: Required<IInitializeServiceOptions>) => {
	const licenseService = new IICsLicenseService(
		new runtime.Configuration({
			fetchApi,
			basePath: serviceBaseURLs.license,
		}),
		tenantId,
	);

	return licenseService;
};
